import { z } from "zod";

/** Öneri / hata bildirimi: panel içinden ekip geri bildirimi. */
export const FEEDBACK_KINDS = ["oneri", "hata", "soru"] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];
export const FEEDBACK_KIND_LABEL: Record<FeedbackKind, string> = { oneri: "Öneri", hata: "Hata", soru: "Soru" };

export const FEEDBACK_PRIORITIES = ["kritik", "yuksek", "orta", "dusuk"] as const;
export type FeedbackPriority = (typeof FEEDBACK_PRIORITIES)[number];
export const FEEDBACK_PRIORITY_LABEL: Record<FeedbackPriority, string> = { kritik: "Kritik", yuksek: "Yüksek", orta: "Orta", dusuk: "Düşük" };

export const FEEDBACK_STATUSES = ["yeni", "planlandi", "yapiliyor", "yapildi", "reddedildi"] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];
export const FEEDBACK_STATUS_LABEL: Record<FeedbackStatus, string> = {
  yeni: "Yeni",
  planlandi: "Planlandı",
  yapiliyor: "Yapılıyor",
  yapildi: "Yapıldı",
  reddedildi: "Yapılmayacak",
};

export const createFeedbackSchema = z.object({
  kind: z.enum(FEEDBACK_KINDS),
  priority: z.enum(FEEDBACK_PRIORITIES).default("orta"),
  title: z.string().trim().min(3, { error: "Kısa bir başlık yazın" }).max(140, { error: "Başlık en fazla 140 karakter" }),
  description: z.string().trim().max(4000, { error: "Açıklama en fazla 4000 karakter" }).default(""),
  /** Bildirimin yapıldığı sayfa (yalnız yol + sorgu). */
  page: z.string().max(500).default(""),
  viewport: z.string().max(40).optional(),
});
export type CreateFeedbackInput = z.input<typeof createFeedbackSchema>;

export const updateFeedbackSchema = z.object({
  status: z.enum(FEEDBACK_STATUSES).optional(),
  priority: z.enum(FEEDBACK_PRIORITIES).optional(),
  /** Yöneticinin yanıtı / notu (bildiren kişi görür). */
  reply: z.string().trim().max(2000).optional(),
});
export type UpdateFeedbackInput = z.infer<typeof updateFeedbackSchema>;

export interface FeedbackDto {
  id: string;
  ref: string | null;
  source: "user" | "report";
  kind: FeedbackKind;
  priority: FeedbackPriority;
  status: FeedbackStatus;
  title: string;
  description: string;
  page: string;
  viewport: string | null;
  browser: string | null;
  hasScreenshot: boolean;
  reply: string | null;
  createdBy: { id: string | null; name: string };
  createdAt: string;
  updatedAt: string;
  updatedBy: string | null;
}

export interface FeedbackListResponse {
  items: FeedbackDto[];
  canManage: boolean;
  reportImported: boolean;
}
